import { FieldComponent } from 'libs/form';
import { ZoneInputBox } from '../styled';
import { FormWrapper, Inputs, Interface, ParamsWrapper, Wrapper, ZoneLabel } from './igora-tariffication.styled';

export const IgoraTariffication = (props) => {
  const { color, display, disabled } = props;

  /**
   * get params for zones
   * @returns
   */
  const getParams = () => {
    // "free_interval": 15,             # минуты
    // "minute_cost": 75,               # копейки
    // "start_paid_time": "09:00:00",
    // "end_paid_time": "09:00:00",

    const fields = [
      { name: 'free_interval', title: 'Бесплатный период, мин', type: 'number' },
      { name: 'monday', title: 'Стоимость в ПН, Р', type: 'number' },
      { name: 'tuesday', title: 'Стоимость в ВТ, Р', type: 'number' },
      { name: 'wednesday', title: 'Стоимость в СР, Р', type: 'number' },
      { name: 'thursday', title: 'Стоимость в ЧТ, Р', type: 'number' },
      { name: 'friday', title: 'Стоимость в ПТ, Р', type: 'number' },
      { name: 'saturday', title: 'Стоимость в СБ, Р', type: 'number' },
      { name: 'sunday', title: 'Стоимость в ВС, Р', type: 'number' },
      { name: 'holiday', title: 'Стоимость в праздник, Р', type: 'number' },
    ];

    const fieldsEl = fields.map((el, idx) => {
      const other = { type: 'text', name: el.name, maxValueLength: 8 };
      if (el.type === 'number') {
        other.naturalNumber = true;
        other.withZero = true;
      }

      return (
        <Inputs key={idx}>
          <ZoneLabel>{el.title}</ZoneLabel>
          <ZoneInputBox wide>
            <FieldComponent disabled={disabled} {...other} />
          </ZoneInputBox>
        </Inputs>
      );
    });

    return (
      <FormWrapper>
        <ParamsWrapper>{fieldsEl}</ParamsWrapper>
      </FormWrapper>
    );
  };

  return (
    <Interface color={color} display={display ? 'block' : 'none'}>
      <Wrapper>{getParams()}</Wrapper>
    </Interface>
  );
};
